// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x-QuickQouteReview {
  display: flex;
  flex-direction: column;
  font-size: 20px;
  align-items: center;
  width: 100%;
}
.x-QuickQouteReview > * {
  margin: 10px;
}
.x-QuickQouteReview-premiumBadge {
  background: #f1fff8;
  border-radius: 5px;
  padding: 20px;
}
`, "",{"version":3,"sources":["webpack://./modules/portal-core/components/QuickQouteReview.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;AACF;AAAE;EACE,YAAA;AAEJ;AAEA;EACE,mBAAA;EACA,kBAAA;EACA,aAAA;AAAF","sourcesContent":[".root {\n  display: flex;\n  flex-direction: column;\n  font-size: 20px;\n  align-items: center;\n  width: 100%;\n  & >  * {\n    margin: 10px;\n  }\n}\n\n.premiumBadge {\n  background: #f1fff8;\n  border-radius: 5px;\n  padding: 20px;\n\n}\n\n.applyNow {\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `x-QuickQouteReview`,
	"premiumBadge": `x-QuickQouteReview-premiumBadge`
};
export default ___CSS_LOADER_EXPORT___;
